import {AppStateChangeListenerBase} from '~/navigation/listeners/app-state-change/app-state-change-listener.base';
import {Listener} from '~/navigation/listeners/listener';

export class AppStateChangeListener extends AppStateChangeListenerBase
  implements Listener {
  public setListener(): void {}
  public unsetListener(): void {}
}
